import { useMyAccountInfo } from "PFCore/hooks/queries/account/use_my_account_info";

export const useBookingPastDaysLimit = (): number => {
  const {
    data: { availability }
  } = useMyAccountInfo();

  const { booking_past_days_limit: bookingPastDaysLimit } = availability || {};

  return bookingPastDaysLimit ?? 0;
};
